import { useEffect } from 'react';
import { Container, Col, Row } from 'react-bootstrap';
import { BzHeading, BzCard, BzChip } from '../../components';
import { useDispatch, useSelector } from 'react-redux';
import { ORDER_ENTRY_BUTTON_TOGGLE, TRADING_NOT_ALLOWED_MSG, WATCHLIST_GRID_INDEX } from '../../utils/global_variables';
import { getMarketPulse } from '../../redux/actions/marketOverview';
import { getScripOrderInfo, getSpreadOrder, updateIsBuyOrSell } from '../../redux/actions/orders';
import { ORDER_ENTRY_GRID_REF, getApiExchangeNameFromMktSegId, getMappedMktSegIdFromApiExchangeName } from '../../utils/global_functions';
import { handleModal, handleModalData } from '../../redux/actions/modals';
import { toastConfig } from '../../redux/actions/toast';
import ZeroStates from '../ZeroStates';
import { sendTouchlineRequest } from '../../apis/web_socket';

const MarketPulse = () => {
    const dispatch = useDispatch();
    const marketPulse = useSelector(state => state?.marketOverview?.marketPulse);
    const scripOverviewData = useSelector(state => state.marketOverview.scripOverviewData);
    const arrScripInfoMarketPulse = useSelector(state => state.marketOverview.arrScripInfoMarketPulse);
    // Vaibhav Singh: BT-109089: 16-11-23: If exchange not allowed BUY/SELL will not open: Start
    const objLoginSession = useSelector(state => state.auth.objLoginSession);
    // Vaibhav Singh: BT-109089: 16-11-23: If exchange not allowed BUY/SELL will not open: End
    //Vaibhav Singh: 30-11-2023: Fixed calling market pulse Calling only 2 as marketSegment pulse header - Start
    useEffect(() => {
        if (scripOverviewData?.length > 0 && !marketPulse) {
            dispatch(getMarketPulse({ mktSegmentId: 2, Symbol: scripOverviewData[WATCHLIST_GRID_INDEX.SYMBOL] }));
        }
    }, [dispatch, marketPulse, scripOverviewData]);
    //Vaibhav Singh: 30-11-2023: Fixed calling market pulse Calling only 2 as marketSegment pulse header - eND
    //Vaibhav Singh: BT-109089: 24-10-2023: added order entry for market pulse
    const setOrderEntryScripPrice = (activeButtonToggleIndex, scripData) => {
        const nAskPrice = parseFloat(scripData[WATCHLIST_GRID_INDEX.ASK_PRICE]);
        const nLTP = parseFloat(scripData[WATCHLIST_GRID_INDEX.LAST_TRADE_PRICE]);
        const nBidPrice = parseFloat(scripData[WATCHLIST_GRID_INDEX.BID_PRICE]);
        if (activeButtonToggleIndex === ORDER_ENTRY_BUTTON_TOGGLE.BUY) {
            if (nAskPrice > 0) {
                ORDER_ENTRY_GRID_REF?.current?.setOrderInputs(curr => ({ ...curr, scripPrice: nAskPrice }));
            } else {
                ORDER_ENTRY_GRID_REF?.current?.setOrderInputs(curr => ({ ...curr, scripPrice: nLTP }));
            }
        } else {
            if (nBidPrice > 0) {
                ORDER_ENTRY_GRID_REF?.current?.setOrderInputs(curr => ({ ...curr, scripPrice: nBidPrice }));
            } else {
                ORDER_ENTRY_GRID_REF?.current?.setOrderInputs(curr => ({ ...curr, scripPrice: nLTP }));
            }
        }
    };
    const handlePlaceOrder = async (scripData, nIsBuyOrSell = 0) => {
        dispatch(getScripOrderInfo({ isBuySell: nIsBuyOrSell, activeExchangeId: scripData?.[WATCHLIST_GRID_INDEX.SEGMENT_ID], scripData: scripData }));
        setOrderEntryScripPrice(nIsBuyOrSell, scripData);
        await dispatch(handleModal([{ 'MARKET_OVERVIEW_MODAL': false }, { 'ORDER_ENTRY_MODAL': true }]));
    };
    const handleClick = (each) => {
        // Vaibhav Singh: BT-109089: 16-11-23: If exchange not allowed BUY/SELL will not open: Start
        const strExchangeName = getApiExchangeNameFromMktSegId(scripOverviewData[WATCHLIST_GRID_INDEX.SEGMENT_ID]);
        if (objLoginSession?.data?.exchanges?.includes(strExchangeName?.toUpperCase())) {
            const scripData = arrScripInfoMarketPulse?.filter((item) => { return item?.[WATCHLIST_GRID_INDEX.SEGMENT_ID_TOKEN] === `${each?.nMarketSegmentId}_${each?.nToken}`; });
            if (scripData?.[0]?.[WATCHLIST_GRID_INDEX?.SYMBOL]?.includes("-")) {
                handleSelectSpreadOrderModel(scripData?.[0], "SELL"); //Ameersha N : 11-03-2024 : BT-107070 - Breeze - Spread Order entry
            } else {
                handlePlaceOrder(scripData?.[0]);
            }
        }
        else {
            dispatch(toastConfig({ autoDismiss: true, show: true, message: TRADING_NOT_ALLOWED_MSG }));
        }
        // Vaibhav Singh: BT-109089: 16-11-23: If exchange not allowed BUY/SELL will not open: End
    };

    const handleSelectSpreadOrderModel = (spreadArr, strBuySell) => {
        dispatch(updateIsBuyOrSell(strBuySell));//Ameersha N : 11-03-2024 : BT-107070 - Breeze - Spread Order entry 
        var spreadPaylod =
        {
            "mktSegid": getMappedMktSegIdFromApiExchangeName(getApiExchangeNameFromMktSegId(spreadArr[WATCHLIST_GRID_INDEX.SEGMENT_ID])),//Ameersha N - 04-03-2024 - Sending Mapped Market Segment ID for spread API,
            "symbol": spreadArr[WATCHLIST_GRID_INDEX.SYMBOL],
            "token": spreadArr[WATCHLIST_GRID_INDEX.TOKEN]
        };
        sendTouchlineRequest([
            { exchangeId: spreadArr[WATCHLIST_GRID_INDEX.SEGMENT_ID], token: spreadArr[WATCHLIST_GRID_INDEX.TOKEN], isSubscribe: true },

        ]);

        dispatch(getSpreadOrder(spreadPaylod));
        dispatch(handleModal([{ 'ORDER_ENTRY_MODAL': true }, true]));
        dispatch(handleModalData({ data: { spreadArr: spreadArr, orderEntryTab: 'multi_scrip', activeTabKey: 'spread' } }), true);
    };

    return (
        <>
            <Container data-testid='market-overview-pulse-section' fluid className='p-0 mt-3'>
                <div className='scripoverview-fieldset'>
                    <div className='scripoverview-legend'>MARKET PULSE</div>
                    <div className='scripoverview-fieldset-sm'>
                        <div className='marketpulse-card-wrap'>
                            {marketPulse?.length ? marketPulse?.map((each, i) => (
                                <BzCard data-testid='market-overview-pulse-card' key={i} className='marketpulse-card' onClick={() => { handleClick(each); }}>
                                    <Row className='g-0 align-items-center mb-2'>
                                        <Col md={6} className='d-flex justify-content-start'>
                                            <BzHeading className='font-medium font-size8 color-text color-positive text-uppercase'>Trade</BzHeading>
                                        </Col>
                                        <Col md={6} className='d-flex justify-content-end'>
                                            <div className='chips-wrap'>
                                                <BzChip className='chips positive-chip'>{each?.sDataDesc}</BzChip>
                                            </div>
                                        </Col>
                                    </Row>
                                    <Row className='g-0'>
                                        <Col md={7} className='d-flex justify-content-start align-items-center'>
                                            <div className='font-medium font-size2 color-text text-uppercase'>{each?.nExpiryDate} {each?.nStrikePrice} {each?.sOptionType}</div>
                                        </Col>
                                        <Col md={5} className='d-flex justify-content-end align-items-center'>
                                            <div className='font-regular font-size2 color-subtext text-uppercase'>{each?.ltp}<span className='color-text'>{each?.nLTP} </span> <span className={`color-text ${each?.nPercChange.substring(0, 1) === '-' ? 'color-negative' : 'color-positive'} m-l-3`}>{each?.nPercChange.substring(0, 1) === '-' ? each?.nPercChange : `+` + each?.nPercChange}%</span></div>
                                        </Col>
                                    </Row>
                                </BzCard>
                            ))
                                :
                                <div className='zero-state-alerts zero-state-alerts-lg'>
                                    <ZeroStates subText="Could not find any data" icon='icon-64 icon-nodata mb-3 mrgauto' />
                                </div>
                            }
                        </div>
                    </div>
                </div>
            </Container>
        </>
    );

};

export default MarketPulse;